var map = {
	"./ZoomPluginsModule.js": 194,
	"./es.upv.paella.canvasZoomInButtonPlugin.js": 45,
	"./es.upv.paella.canvasZoomOutButtonPlugin.js": 147,
	"./es.upv.paella.zoomInButtonPlugin.js": 392,
	"./es.upv.paella.zoomMenuButtonPlugin.js": 410,
	"./es.upv.paella.zoomOutButtonPlugin.js": 426,
	"./es.upv.paella.zoomPlugin.js": 629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 757;